import Vue from 'vue'
import './api/config'
import App from './App.vue'
import router from './router'
import store from './store/store'
import Vuetify from 'vuetify'
import { vuetifyTheme } from '@/themes'
import 'vuetify/dist/vuetify.min.css'
// TODO: add babel polyfil with import
import '@babel/polyfill'
// plugins
import moment from 'moment'
import _ from 'underscore'
import log from 'loglevel'

// remove log on production
if (!process.env.VUE_APP_DEBUG || process.env.VUE_APP_DEBUG === 'false') {
  log.disableAll()
} else {
  log.setLevel('debug')
}

// plugins declared globally
Vue.prototype.$moment = moment
Vue.prototype.$log = log
Vue.prototype.$_ = _
Vue.prototype.$env = { ...process.env }
Vue.config.productionTip = false
Vue.use(Vuetify, vuetifyTheme)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
